import React, { useEffect } from "react";

import deleteIcon from "../assets/icons/delete.png";
import dlicon from "../assets/icons/dlicon.png";
import upIcon from "../assets/icons/up.png";
import downIcon from "../assets/icons/down.png";
import questionIcon from "../assets/icons/question-mark.png";
import reset from "../assets/icons/reset.png";

function HelpModal({ onClose, isDesktop }) {
	if (isDesktop) {
		// -- DESKTOP MODAL: uses a standard centered overlay --
		return (
			<div
			className="fixed inset-0 z-50 flex items-center justify-center bg-black/80"
			onClick={onClose}
		  >
			{/* Modal content box */}
			<div
			  className="relative min-h-[50vh] w-[90%] max-w-3xl p-6 text-white rounded bg-monadBg overflow-hidden"
			  // Stop clicks inside the modal from propagating to the backdrop
			  onClick={(e) => e.stopPropagation()}
			>
			  {/* Optional semi-transparent background image */}
			  <div
				className="absolute inset-0 bg-center bg-cover opacity-15"
				style={{
				  backgroundImage: `url("https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/hornelius_no_bg.png")`,
				}}
			  />
			  {/* Actual content on top */}
			  <div className="relative">
				{/* Instructions */}
				<h2 className="text-lg font-bold mb-2 mt-10 text-center">
				  Choose a background image to begin
				</h2>
				<div className="flex justify-center mb-2">
				  <ul className="list-disc list-inside text-left text-lg">
					<li>Upload your own image</li>
					<li>Popular imgflip meme template</li>
					<li>NFTs from wallet address</li>
					<li>Sappy Seals Meme Machine</li>
				  </ul>
				</div>
				<h2 className="font-bold mb-2 text-center text-lg">Add text and style it</h2>
				<h2 className="font-bold mb-2 text-center text-lg">
				  Add any of the available assets to your meme
				</h2>
				<h2 className="font-bold mb-2 text-center text-lg">Deep fry it | Download it</h2>
				<h2 className="font-bold mb-2 text-center text-lg">
				  Built by{" "}
				  <a
					href="https://x.com/hornelius"
					target="_blank"
					rel="noopener noreferrer"
					className="text-blue-300 hover:underline text-lg"
				  >
					hornelius.eth{" "}
				  </a>
				  |{" "}
				  <a
					href="https://x.com/sealuminati"
					target="_blank"
					rel="noopener noreferrer"
					className="text-blue-300 hover:underline text-lg"
				  >
					sealuminati
				  </a>{" "}
				  dev
				</h2>
				<h2 className="font-bold mb-2 text-center">Click outside of this box to close</h2>
	
				{/* Icon row */}
				<div className="mt-36 flex flex-wrap justify-center items-center gap-6">
				  {/* Download */}
				  <div className="flex flex-col items-center">
					<img
					  src={dlicon}
					  alt="Download icon"
					  className="w-10 h-10 block object-contain shrink-0"
					/>
					<span className="text-md mt-1">Download Meme</span>
				  </div>
	
				  {/* Delete */}
				  <div className="flex flex-col items-center">
					<img
					  src={deleteIcon}
					  alt="Delete icon"
					  className="w-8 h-8 block object-contain shrink-0 mt-2"
					/>
					<span className="text-md mt-1">Delete Selected</span>
				  </div>
	
				  {/* Layer Up */}
				  <div className="flex flex-col items-center">
					<img
					  src={upIcon}
					  alt="Layer Up icon"
					  className="w-10 h-10 block object-contain shrink-0 mt-2"
					/>
					<span className="text-md -mt-1">Layer Up</span>
				  </div>
	
				  {/* Layer Down */}
				  <div className="flex flex-col items-center">
					<img
					  src={downIcon}
					  alt="Layer Down icon"
					  className="w-10 h-10 block object-contain shrink-0 mt-3"
					/>
					<span className="text-md -mt-1">Layer Down</span>
				  </div>
	
				  {/* Reset */}
				  <div className="flex flex-col items-center">
					<img
					  src={reset}
					  alt="Reset icon"
					  className="w-10 h-10 block object-contain shrink-0 mt-1"
					/>
					<span className="text-md mt-1">Reset Canvas</span>
				  </div>
	
				  {/* Info */}
				  <div className="flex flex-col items-center">
					<img
					  src={questionIcon}
					  alt="Info icon"
					  className="w-10 h-1- block object-contain shrink-0 mt-1"
					/>
					<span className="text-md mt-1">Help</span>
				  </div>
				</div>
			  </div>
			</div>
		  </div>
		);
	  }
	  else {
		return (
			// Full-screen overlay (dark backdrop behind modal box)
			<div
        className="fixed inset-0 z-50 flex -mt-40 items-center justify-center bg-black/80"
        onClick={onClose}
      >
        <div
          className="relative w-[90%] max-w-md p-6 text-white rounded bg-monadBg overflow-hidden"
          // Stop clicks inside the modal from propagating to the backdrop
          onClick={(e) => e.stopPropagation()}
        >
          {/* Semi-transparent image behind content */}
          <div
            className="absolute inset-0 bg-center bg-cover opacity-10"
            style={{
              backgroundImage: `url("https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/hornelius_no_bg.png")`,
            }}
          />

          <div className="relative">
            {/* Instructions content */}
            <h2 className="font-bold mb-2 text-center">
              Choose a background image to begin
            </h2>
            <div className="flex justify-center mb-2">
              <ul className="list-disc list-inside text-left">
                <li>Upload your own image</li>
                <li>Popular imgflip meme template</li>
                <li>NFTs from wallet address</li>
                <li>Sappy Seals Meme Machine</li>
              </ul>
            </div>

            <h2 className="font-bold mb-2 text-center">Add text and style it</h2>
            <h2 className="font-bold mb-2 text-center">
              Add any of the available assets to your meme
            </h2>
            <h2 className="font-bold mb-2 text-center">Deep fry it | Download it</h2>
            <h2 className="font-bold mb-2 text-center">
              Built by{" "}
              <a
                href="https://x.com/hornelius"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-300 hover:underline"
              >
                hornelius.eth{" "}
              </a>
              |{" "}
              <a
                href="https://x.com/sealuminati"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-300 hover:underline"
              >
                sealuminati
              </a>{" "}
              dev
            </h2>
			<h2 className="font-bold mb-2 text-center">Click outside of this box to close</h2>

            {/* Icon row */}
            <div className="mt-10 flex flex-wrap justify-center items-center gap-6">
              {/* Download */}
              <div className="flex flex-col items-center">
                <img
                  src={dlicon}
                  alt="Download icon"
                  className="w-6 h-6 block object-contain shrink-0"
                />
                <span className="text-xs mt-1">Download Meme</span>
              </div>

              {/* Delete */}
              <div className="flex flex-col items-center">
                <img
                  src={deleteIcon}
                  alt="Delete icon"
                  className="w-6 h-6 block object-contain shrink-0"
                />
                <span className="text-xs mt-1">Delete Selected</span>
              </div>

              {/* Layer Up */}
              <div className="flex flex-col items-center">
                <img
                  src={upIcon}
                  alt="Layer Up icon"
                  className="w-6 h-6 block object-contain shrink-0"
                />
                <span className="text-xs mt-1">Layer Up</span>
              </div>

              {/* Layer Down */}
              <div className="flex flex-col items-center">
                <img
                  src={downIcon}
                  alt="Layer Down icon"
                  className="w-6 h-6 block object-contain shrink-0"
                />
                <span className="text-xs mt-1">Layer Down</span>
              </div>

              {/* Reset */}
              <div className="flex flex-col items-center">
                <img
                  src={reset}
                  alt="Reset icon"
                  className="w-6 h-6 block object-contain shrink-0"
                />
                <span className="text-xs mt-1">Reset Canvas</span>
              </div>

              {/* Info */}
              <div className="flex flex-col items-center">
                <img
                  src={questionIcon}
                  alt="Info icon"
                  className="w-6 h-6 block object-contain shrink-0"
                />
                <span className="text-xs mt-1">Help</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default HelpModal;